<mat-card>
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <h3 class="page-header">Embedded Questions</h3>
    <button mat-raised-button color="primary" (click)="addQuestion()">Add Question</button>
  </mat-card-title>
  <mat-card-content>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

      <!-- Question Text Column -->
      <ng-container matColumnDef="questionText">
        <th mat-header-cell *matHeaderCellDef> Question Text </th>
        <td mat-cell *matCellDef="let element"> {{element.questionText}} </td>
      </ng-container>

      <!-- Question Type Column -->
      <ng-container matColumnDef="questionType">
        <th mat-header-cell *matHeaderCellDef> Question Type </th>
        <td mat-cell *matCellDef="let element"> {{element.questionType}} </td>
      </ng-container>

      <!-- Date Updated Column -->
      <ng-container matColumnDef="dateUpdated">
        <th mat-header-cell *matHeaderCellDef> Date Updated </th>
        <td mat-cell *matCellDef="let element"> {{element.dateUpdated | date}} </td>
      </ng-container>

      <!-- Updated By Column -->
      <ng-container matColumnDef="updatedBy">
        <th mat-header-cell *matHeaderCellDef> Updated By </th>
        <td mat-cell *matCellDef="let element"> {{element.updatedBy}} </td>
      </ng-container>

      <!-- Action Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef> Action </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button (click)="editQuestion(element)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="deleteQuestion(element)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [colSpan]="displayedColumns.length" style="text-align: center; padding: 24px;">
          No embedded questions found.
        </td>
      </tr>
    </table>
  </mat-card-content>
</mat-card>
